// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var RateLimitsController = function ($scope, $http, RateLimit) {

    $scope.wasSearching = false;
    $scope.filters = {};
    $scope.updateFilter = function () {
        $scope.limits = $scope.paginator(function (options, callback) {
            return RateLimit.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { search: $scope.filters.search, count: $scope.filters.count }, 100);
    };

    $scope.resetFiltersAndRead = function() {
        $scope.filters.search = "";
        $scope.filters.count = "";
        $scope.updateFilter();
    };

    $scope.resetFiltersAndRead();

    //$scope.limits = RateLimit.query();

    function resetRateLimit(bucketId) {
        $http.post('/api/v1/ratelimits/' + encodeURIComponent(bucketId), {})
            .success(function () { window.location.reload(); });
    }

    $scope.resetRateLimit = function (bucketId) {
        $scope.confirm("Rate limits", "Are you sure you want to reset rate limit?", resetRateLimit.bind(this, bucketId))
    };
};
RateLimitsController.$inject = ['$scope', '$http', 'RateLimit'];
